import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

var _container;
var scrollbarWidth = 12;
var containerScrollbar = {
  scrollbar: {
    '-webkit-appearance': 'none',
    backgroundClip: 'content-box',
    width: '16px',
    height: '16px'
  },
  track: {
    bg: 'transparent'
  },
  thumb: {
    borderRadius: 'pill'
  }
};
var scrollbar = {
  basic: {
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      backgroundClip: 'content-box',
      border: '1px solid transparent',
      borderRadius: "".concat(scrollbarWidth / 2, "px"),
      width: "".concat(scrollbarWidth, "px"),
      height: "".concat(scrollbarWidth, "px")
    },
    '&::-webkit-scrollbar-track': {
      bg: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: "".concat(scrollbarWidth / 2, "px"),
      boxShadow: "inset 0 0 0 ".concat(scrollbarWidth / 2, "px #bfc4c8"),
      border: '2px solid transparent'
    }
  },
  transition: {
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      backgroundClip: 'content-box',
      border: '1px solid transparent',
      borderRadius: "".concat(scrollbarWidth / 2, "px"),
      width: "".concat(scrollbarWidth, "px"),
      height: "".concat(scrollbarWidth, "px")
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      boxShadow: "inset 0 0 0 ".concat(scrollbarWidth / 2, "px transparent"),
      borderRadius: "".concat(scrollbarWidth / 2, "px"),
      border: '2px solid transparent'
    },
    '&:hover::-webkit-scrollbar-thumb': {
      boxShadow: "inset 0 0 0 ".concat(scrollbarWidth / 2, "px #bfc4c8")
    }
  },
  container: (_container = {}, _defineProperty(_container, THEME_UI_DEFAULT_KEY, {
    '&::-webkit-scrollbar': _objectSpread2(_objectSpread2({}, containerScrollbar.scrollbar), {}, {
      bg: 'white'
    }),
    '&::-webkit-scrollbar-track': containerScrollbar.track,
    '&::-webkit-scrollbar-thumb': _objectSpread2(_objectSpread2({}, containerScrollbar.thumb), {}, {
      bg: 'neutral',
      border: 'white.thicker'
    })
  }), _defineProperty(_container, 'lighter-bg', {
    '&::-webkit-scrollbar': _objectSpread2(_objectSpread2({}, containerScrollbar.scrollbar), {}, {
      bg: 'lighter'
    }),
    '&::-webkit-scrollbar-track': containerScrollbar.track,
    '&::-webkit-scrollbar-thumb': _objectSpread2(_objectSpread2({}, containerScrollbar.thumb), {}, {
      bg: 'neutral',
      border: 'neutral.lighter.thicker'
    })
  }), _defineProperty(_container, 'subtlest-bg', {
    '&::-webkit-scrollbar': _objectSpread2(_objectSpread2({}, containerScrollbar.scrollbar), {}, {
      bg: 'neutral.subtlest'
    }),
    '&::-webkit-scrollbar-track': containerScrollbar.track,
    '&::-webkit-scrollbar-thumb': _objectSpread2(_objectSpread2({}, containerScrollbar.thumb), {}, {
      bg: 'neutral',
      border: 'neutral.subtlest.thicker'
    })
  }), _defineProperty(_container, 'light-bg', {
    '&::-webkit-scrollbar': _objectSpread2(_objectSpread2({}, containerScrollbar.scrollbar), {}, {
      bg: 'neutral.light'
    }),
    '&::-webkit-scrollbar-track': containerScrollbar.track,
    '&::-webkit-scrollbar-thumb': _objectSpread2(_objectSpread2({}, containerScrollbar.thumb), {}, {
      bg: 'neutral.medium',
      border: 'neutral.light.thicker'
    })
  }), _container),
  'text-area': {
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      backgroundClip: 'content-box',
      width: '12px',
      bg: 'white'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      bg: 'neutral.medium',
      borderRadius: '6px',
      border: '3px solid white'
    }
  }
};

export { scrollbar, scrollbarWidth };
//# sourceMappingURL=scrollbar.esm.js.map
